import { Fragment, useState } from "react";
import { useStore, useCart } from "../../hooks";
import { CartItemModel, StoreProductModel } from "../../models";
import { DashLg, PlusLg } from "react-bootstrap-icons";
import { formatCurrency } from "../../utilities";
import { ProductAddOnModal } from "..";
import { useCartPrice } from "../../hooks";
import { isEmpty, ucwords } from "../../helpers";
import clsx from "clsx";
import { MAX_PRODUCT_QUANTITY } from "../../constants";

type Props = {
  index: number;
  cartItem: CartItemModel;
  editable?: boolean | undefined;
};

const CartProduct: React.FC<Props> = ({ index, cartItem, editable }) => {
  const { storeProducts } = useStore();
  const { increaseQuantity, decreaseQuantity, isLoading } = useCart();

  const [activeModal, setActiveModal] = useState<
    "productDetail" | "productAddon" | null
  >(null);
  const [storeProduct, setStoreProduct] = useState<
    StoreProductModel | undefined
  >();

  const handleCustomization = (cartItem: CartItemModel) => {
    const product = storeProducts.find(
      (item) => item.id === cartItem.product_id,
    );
    setStoreProduct(product);
    setActiveModal("productAddon");
  };

  const handleUpdate = () => {
    setActiveModal(null);
  };

  const handleClose = () => setActiveModal(null);

  const isDisabled = cartItem.product_disabled === "1";

  const cartPrice = useCartPrice(cartItem);

  return (
    <>
      <li>
        <div className="your_order_colm">
          <h5
            className={clsx(
              "fw-bold",
              isDisabled ? "text-danger" : "text-success",
            )}
          >
            {ucwords(cartItem.product_name)}
          </h5>

          <p>{cartItem.product_instruction}</p>
          {editable && (
            <span
              className="cursor-pointer product-customize mb-3"
              onClick={() => handleCustomization(cartItem)}
            >
              customize
            </span>
          )}
          {cartItem?.modifier_group
            .filter((item) => item.g_parent_id === "0")
            .map((modifierGroup, modifierGroupIndex) => {
              return (
                <p key={modifierGroupIndex} className="extras_row">
                  <span className="d-block">
                    <strong>{modifierGroup.g_name}</strong>
                  </span>
                  {modifierGroup.modifiers.map((modifier, modifierIndex) => {
                    const nestedModifierGroup = cartItem?.modifier_group.find(
                      (nestedItem) => nestedItem.g_parent_id == modifier.m_id,
                    );
                    return (
                      <Fragment key={modifierIndex}>
                        <span className="d-block">
                          {modifier.m_name}{" "}
                          {!isEmpty(modifier?.prices || []) && (
                            <>
                              {" "}
                              (
                              {(modifier?.prices || [])
                                .map((a) => a.name)
                                .join(", ")}
                              )
                            </>
                          )}
                        </span>
                        {nestedModifierGroup && (
                          <span className="ps-4 d-block">
                            <span className="d-block">
                              <strong>{nestedModifierGroup.g_name}</strong>
                            </span>
                            <span className="d-block">
                              {nestedModifierGroup?.modifiers
                                .map((nestedItem) => nestedItem.m_name)
                                .join(", ")}
                            </span>
                          </span>
                        )}
                      </Fragment>
                    );
                  })}
                </p>
              );
            })}
        </div>
        <div className="your_order_colm2">
          {editable && (
            <div className="your_order_main flex-column">
              {/* <div className="delete-btn">
                <button onClick={() => removeFromCart(key)}>
                  <img src={toAbsoluteUrl("/images/delete-btn.svg")} alt="" />
                </button>
              </div> */}
              <div className="input-group-number justify-content-between gap-1 px-2 py-0">
                <button type="button" onClick={() => decreaseQuantity(index)}>
                  <DashLg size={16} className="text-muted" />
                </button>
                <input
                  type="number"
                  name="quantity"
                  min={1}
                  value={cartItem.product_qty}
                  readOnly
                />
                <button
                  type="button"
                  onClick={() => increaseQuantity(index)}
                  disabled={cartItem.product_qty >= MAX_PRODUCT_QUANTITY}
                >
                  <PlusLg size={16} className="text-muted" />
                </button>
              </div>

              {/* {isLoading && <InfiniteLoader />} */}
            </div>
          )}

          {!isLoading && (
            <h6 className="pt-0">
              {!editable && (
                <span className="pe-4 text-nowrap">
                  {"x"} {cartItem.product_qty}
                </span>
              )}

              {Number(cartItem.product_discount) > 0 && (
                <span className="cut-price text-danger text-decoration-line-through me-1">
                  {formatCurrency(cartPrice)}
                </span>
              )}

              {formatCurrency(cartPrice - Number(cartItem.product_discount))}
            </h6>
          )}
        </div>
      </li>

      {storeProduct && (
        <ProductAddOnModal
          mode="edit"
          index={index}
          product={storeProduct}
          cartProduct={cartItem}
          show={activeModal === "productAddon"}
          handleSubmit={handleUpdate}
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default CartProduct;
